import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BaseFpxFormComponent } from '@common/utils';
import { PaymentsFiltertHelper, PaymentsFiltertState } from './services/payments-filter.helper';
import { PaymentsFilterService } from './services/payments-filter.service';

@Component({
  selector: 'app-payments-filter',
  templateUrl: './payments-filter.component.html',
  styleUrls: ['./payments-filter.component.scss'],
  providers: [
    PaymentsFiltertHelper,
    PaymentsFilterService
  ]
})
export class PaymentsFilterComponent extends BaseFpxFormComponent<PaymentsFiltertHelper, PaymentsFiltertState> {

  constructor(
    _formBuilder: FormBuilder,
    private _router: Router,
    private _matDialogRef: MatDialogRef<PaymentsFilterComponent>,
    public _paymentsFiltertHelper: PaymentsFiltertHelper,
  ) {
    super(_formBuilder, _router, _paymentsFiltertHelper);
  }

  override doPreInit() {
    this.initializeForm();
  }

  override doPostInit() {

    let paymentHistoryFilterValue = this._paymentsFiltertHelper._transferServices.paymentHistoryFilterValue;
    if (paymentHistoryFilterValue) {
      this.formGroup.controls['fromDate'].patchValue(paymentHistoryFilterValue.fromDate, { emitEvent: false });
      this.formGroup.controls['toDate'].patchValue(paymentHistoryFilterValue.toDate, { emitEvent: false });
      this.state.catagoryType = paymentHistoryFilterValue.catagoryType;
    } else {
      this.state.catagoryType = 'all';
    }
  }

  protected doDestroy(): void {

  }

  initializeForm() {
    this.addFormControl("fromDate", "", [], []);
    this.addFormControl("toDate", "", [], []);
  }

  chooseFilter(e, filter) {
    this.state.catagoryType = filter;
  }

  override doConfirm(formGroup: FormGroup) {

  }

  submit() {
    this._paymentsFiltertHelper.doConfirm(
      this.formGroup.value,
      (res) => {
        this._matDialogRef.close()
      },
      (err) => {

      }
    );
  }

  reset() {
    this.formGroup.controls['fromDate'].patchValue('',{ emitEvent: false });
    this.formGroup.controls['toDate'].patchValue('',{ emitEvent: false });
    this.formGroup.get("fromDate").reset('', { emitEvent: false });
    this.formGroup.get("toDate").reset('', { emitEvent: false });
    this.formGroup.get("fromDate").setErrors(null, { emitEvent: false });
    this.formGroup.get("toDate").setErrors(null, { emitEvent: false });
    this.state.catagoryType = 'all';
  }

}